import { render, staticRenderFns } from "./customer-source.vue?vue&type=template&id=1ffc334d&scoped=true&"
import script from "./customer-source.vue?vue&type=script&lang=js&"
export * from "./customer-source.vue?vue&type=script&lang=js&"
import style0 from "./customer-source.vue?vue&type=style&index=0&id=1ffc334d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffc334d",
  null
  
)

export default component.exports